var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-tr",
    { key: _vm.logId, attrs: { props: _vm.props } },
    [
      _c("q-td", { key: "place", attrs: { props: _vm.props } }, [
        _vm._v(_vm._s(_vm.place))
      ]),
      _vm._v(" "),
      _c("q-td", { key: "name", attrs: { props: _vm.props } }, [
        _vm._v(_vm._s(_vm.palletNo))
      ]),
      _vm._v(" "),
      _c("q-td", { key: "species", attrs: { props: _vm.props } }, [
        _vm._v(_vm._s(_vm.speciesName))
      ]),
      _vm._v(" "),
      _c("q-td", { key: "palletArea", attrs: { props: _vm.props } }, [
        _vm._v(_vm._s(_vm._f("number")(_vm.palletArea, _vm.userLocale)))
      ]),
      _vm._v(" "),
      _c(
        "q-td",
        { key: "palletResultAreaNotRemeasured", attrs: { props: _vm.props } },
        [
          _vm._v(
            _vm._s(
              _vm._f("number")(_vm.resultAreaNotRemeasured, _vm.userLocale)
            )
          )
        ]
      ),
      _vm._v(" "),
      _c("q-td", { key: "inPalletPercentage", attrs: { props: _vm.props } }, [
        _vm._v(
          _vm._s(
            _vm._f("number")(
              (_vm.resultAreaNotRemeasured / _vm.palletArea) * 100,
              _vm.userLocale,
              0,
              0
            )
          ) + "%"
        )
      ]),
      _vm._v(" "),
      _c("q-td", { key: "palletResultArea", attrs: { props: _vm.props } }, [
        _vm._v(
          _vm._s(_vm._f("number")(_vm.resultAreaMeasuredBack, _vm.userLocale))
        )
      ]),
      _vm._v(" "),
      _c("q-td", { key: "percentageArea", attrs: { props: _vm.props } }, [
        _vm._v(
          _vm._s(
            _vm._f("number")(
              (_vm.resultAreaMeasuredBack / _vm.resultAreaNotRemeasured) * 100,
              _vm.userLocale,
              0,
              0
            )
          ) + "%"
        )
      ]),
      _vm._v(" "),
      _c("q-td", { key: "maxLength", attrs: { props: _vm.props } }, [
        _vm._v(_vm._s(_vm._f("number")(_vm.maxLength, _vm.userLocale)))
      ]),
      _vm._v(" "),
      _c("q-td", { key: "bundleCount", attrs: { props: _vm.props } }, [
        _vm._v(_vm._s(_vm.bundleCount))
      ]),
      _vm._v(" "),
      _c("q-td", { key: "palletInfo", attrs: { props: _vm.props } }, [
        _vm._v(_vm._s(_vm.palletInfo))
      ]),
      _vm._v(" "),
      _c("q-td", { key: "palletInfoInternal", attrs: { props: _vm.props } }, [
        _vm._v(_vm._s(_vm.palletInfoInternal))
      ]),
      _vm._v(" "),
      _c(
        "q-td",
        { key: "actions", attrs: { props: _vm.props } },
        [
          _vm.user
            ? _c(
                "q-btn",
                {
                  attrs: { color: "primary", icon: "launch", dense: "" },
                  on: {
                    click: function($event) {
                      return _vm.$emit("showPalletLogList", _vm.pallet)
                    }
                  }
                },
                [
                  _c("q-tooltip", [_vm._v(_vm._s(_vm.$t("button.palletLogs")))])
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }